import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import style from "./Services.module.css";
import webDevelopment from "../../../assets/web-development.png";
import webDesign from "../../../assets/webDesign.png";
import figma from "../../../assets/figma.png";
import "../Service.css";

const Services = () => {
  return (
    <div className={style.service__container}>
      <h4 className={style.service__title}>Services</h4>
      <h1>
        <span style={{ color: "#DD1C63" }}>WHAT</span> I{" "}
        <span className={style.heilight}>DO</span>
      </h1>
      <Container>
        <div className="mt-5">
          <div className="row">
            <div className="col-lg-4 col-sm-6">
              <div className="item">
                <span className="icon icon-2">
                  <img style={{ width: "70%" }} src={webDesign} alt="img" />
                </span>
                <h4>WEB DESIGN</h4>
                <p>
                  I am expert in web designing. I can add functionality besides
                  designing a webpage. I use HTML, CSS, Bootstrap, Vanilla Js,
                  React JS for it. You can see some of my works below
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6">
              <div className="item">
                <span className="icon icon-3">
                  <img style={{ width: "70%" }} src={figma} alt="img" />
                </span>
                <h4>FIGMA OR PSD COVERT</h4>
                <p>
                  I can covert any PSD or Figma design to a responsive webpage.
                  I use HTML, CSS, Bootstrap, Vanilla Js, React JS, Next Js, for
                  it. You can see some of my works in portfolio tab in this
                  website
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="item">
                <span className="icon icon-1">
                  <img
                    className={style.service_img}
                    style={{ width: "60%" }}
                    src={webDevelopment}
                    alt="img"
                  />
                </span>
                <h4>WEB DEVELOPMENT</h4>
                <p>
                  I am a MERN stack web developer.I love to build attractive and
                  dynamic website. I use MongoDB for database and Express JS,
                  Node Js for server side work.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* <Container>
        <div className={style.service__content}>
          <Row>
            <Col xs={12} sm={12} md={4}>
              <div className={style.service}>
                <div className={style.service__img}>
                  <img className="img-fluid" src={webDevelopment} alt="img" />
                </div>
                <h3>WEB DEVELOPMENT</h3>
                <p>
                  I am a MERN stack web developer. I use MongoDB for database
                  and Express JS, Node Js for server side work.You can see some
                  of my works in portfolio tab in this website
                </p>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4}>
              <div className={style.service}>
                <div className={style.service__img}>
                  <img src={figma} alt="img" />
                </div>
                <h3>PAS/FIGMA CONVERT</h3>
                <p>
                  I am a MERN stack web developer. I use MongoDB for database
                  and Express JS, Node Js for server side work.You can see some
                  of my works in portfolio tab in this website
                </p>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4}>
              <div className={style.service}>
                <div className={style.service__img}>
                  <img src={webDesign} alt="img" />
                </div>
                <h3>WEB DESIGN</h3>
                <p>
                  I am a MERN stack web developer. I use MongoDB for database
                  and Express JS, Node Js for server side work.You can see some
                  of my works in portfolio tab in this website
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container> */}
    </div>
  );
};

export default Services;
